export default {
    "getProductVariants": "6aaa992b354e33431b8a0d312a0f27886fe5f54b2cec4c30c4b04ba8d9e3ca31"
};
